import { Avatar, Box, Button, Divider, Grid, Grid2, IconButton, LinearProgress, List, ListItem, ListItemText, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ArrowBackIos, ArrowBackIosNew, ArrowForwardIos, DriveFileRenameOutlineOutlined, Info, Refresh } from '@mui/icons-material'
import UsageChart from '../../components/layouts/UsageChart'
import { callApiAction } from '../../store/actions/commonAction'
import CustomBarChart from '../../components/layouts/CustomBarChart'
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";import MaskingAudioController from '../therapy/MaskingAudioController'
import { getPatientByIdApi } from '../../apis/patient.api'
import group from '../../assets/images/Group.svg'
import { fetchDailyUsageTimeApi, fetchUsageTimeApi, fetchUsageTimeByTherapyApi } from '../../apis/usageAppTime'
import moment from 'moment'


import CustomDialog from "../../components/layouts/common/CustomDialog";
import { closeModal, openModal } from '../../store/actions/modalAction'
import PatientInformationView from '../patient details dashboard/PatientInformationView'
import { GENDER } from '../../utils/constants'
import { QrCodeModal } from '../patient details dashboard/PatientQrCode'
import { calculateAge, findObjectKeyByValue } from '../../utils/helper'
import { FlexedColumnBox } from '../../components/layouts/common/boxes'
import { FilterTitleBox } from '../../components/layouts/OneViewBox'
import PatientDashboardUi from './PatientDashboardUi';

console.log("PatientDashboardUi:", PatientDashboardUi);

const PatientDashboardController = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  // const maskingButton = () =>{
  //   dispatch(openModal(<MaskingAudioController />, "lg", false, "masking"))
  //   navigate("/therapy");
  // }
  const [loading, setLoading] = useState([]);
  const [patient, setPatient] = useState({});
  const [therapyUsage, setTherapyUsage] = useState([]);

  const [todayUsage, setTodayUsage] = useState({
    value: 0,
    gradientColors: ["#F2653A", "#AA218E"],
  });
  const [weeklyUsage, setWeeklyUsage] = useState({
    value: 0,
    gradientColors: ["#28A745", "#2185D0"],
  });
  const fetchApi = getPatientByIdApi;

  const onclickButton = () => {
    navigate(`/therapy/${params.id}`, {
      state: { PatientFrequency: parseInt(patient?.frequency) },
    });
  };

  const fetchPatient = (id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchApi({ id: params.id }),
        (response) => {
          setPatient(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  const fetchDailyUsageTime = (id) => {
    setLoading(true);

    const startDate = moment().startOf("day").toISOString();
    const endDate = moment().endOf("day").toISOString();

    // console.log("Fetching daily data...");

    // Fetch Daily Usage Data
    dispatch(
      callApiAction(
        async () =>
          await fetchDailyUsageTimeApi({
            patient_id: id,
            startDate,
            endDate,
          }),
        (dailyResponse) => {
          // console.log("Daily Response:", dailyResponse); // Debugging

          if (dailyResponse && dailyResponse.length > 0) {
            const dailyData = dailyResponse[0]; // Ensure correct data structure

            const todayUsageMinutes =
              (dailyData.hours ?? 0) * 60 + (dailyData.minutes ?? 0);
            const selectedSchedule = dailyData.selected_schedule ?? 0;

            // console.log("Today Usage:", todayUsageMinutes);
            // console.log("Selected Schedule:", selectedSchedule);

            setTodayUsage({
              value: todayUsageMinutes,
              maxValue: selectedSchedule,
              displayValue: formatTime(todayUsageMinutes),
              gradientColors: ["#F2653A", "#AA218E"],
            });
          } else {
            console.warn("No daily data received");
            setTodayUsage({
              value: 0,
              maxValue: 0,
              displayValue: "0h 0m",
              gradientColors: ["#F2653A", "#AA218E"],
            });
          }

          console.log("Fetching weekly data...");

          // Fetch Weekly Usage Data After Daily Data is Loaded
          dispatch(
            callApiAction(
              async () =>
                await fetchDailyUsageTimeApi({
                  patient_id: id,
                  startDate,
                  weekly: true,
                }),
              (weeklyResponse) => {
                // console.log("Weekly Response:", weeklyResponse); // Debugging

                if (weeklyResponse && weeklyResponse.length > 0) {
                  const weeklyData = weeklyResponse[0];

                  const weeklyUsageMinutes =
                    (weeklyData.hours ?? 0) * 60 + (weeklyData.minutes ?? 0);
                  const weekSchedule = weeklyData.week_schedule ?? 0;

                  // console.log("Weekly Usage:", weeklyUsageMinutes);
                  // console.log("Week Schedule:", weekSchedule);

                  setWeeklyUsage({
                    value: weeklyUsageMinutes,
                    maxValue: weekSchedule,
                    displayValue: formatTime(weeklyUsageMinutes),
                    gradientColors: ["#28A745", "#2185D0"],
                  });
                } else {
                  console.warn("No weekly data received");
                  setWeeklyUsage({
                    value: 0,
                    maxValue: 0,
                    displayValue: "0h 0m",
                    gradientColors: ["#28A745", "#2185D0"],
                  });
                }

                setLoading(false);
              },
              (err) => {
                console.error("Weekly API Error:", err);
                setLoading(false);
              }
            )
          );
        },
        (err) => {
          console.error("Daily API Error:", err);
          setLoading(false);
        }
      )
    );
  };

  // Helper function to format time
  const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  useEffect(() => {
    fetchDailyUsageTime(params.id);
  }, []);

  const fetchTherapyUsage = (id) => {
    setLoading(true);

    const startDate = moment().startOf("day").toISOString();

    dispatch(
      callApiAction(
        async () =>
          await fetchUsageTimeByTherapyApi({
            patient_id: id,
            startDate,
          }),
        (response) => {
          // console.log("Therapy Usage Response:", response);

          if (response && response.length > 0) {
            const formattedData = response.map((item) => ({
              name: item.therapy_id ? item.therapy_id : item.name || "Unknown Therapy",
              usage: item.total_usage_time
                ? Math.floor(item.total_usage_time / 60000)
                : 0, // Convert ms to minutes
              maxUsage: item.selected_schedule ?? 0,
            }));

            setTherapyUsage(formattedData);
          } else {
            setTherapyUsage([]);
          }

          setLoading(false);
        },
        (err) => {
          console.error("Therapy API Error:", err);
          setLoading(false);
        }
      )
    );
  };

  const [selectedDate, setSelectedDate] = useState(moment());
  const [isMonthly, setIsMonthly] = useState(true);
  const [usageData, setUsageData] = useState({});

  const fetchUsageChartData = (selectedDate, isMonthlyView) => {
    if (!selectedDate || !moment.isMoment(selectedDate)) return;

    const startDate = isMonthlyView
      ? selectedDate.clone().startOf("month").toISOString()
      : selectedDate.clone().startOf("week").toISOString();

    const endDate = isMonthlyView
      ? selectedDate.clone().endOf("month").toISOString()
      : selectedDate.clone().endOf("week").toISOString();

    dispatch(
      callApiAction(
        async () =>
          await fetchUsageTimeApi({
            patient_id: params.id,
            startDate,
            endDate,
          }),
        (response) => {
          const usageMap = {};
          response?.forEach((item) => {
            const dateKey = moment(item.date).format("YYYY-MM-DD");
            usageMap[dateKey] = item.minutes || 0; // Directly store minutes value
          });

          setUsageData(usageMap);
        }
      )
    );
  };

  useEffect(() => {
    fetchUsageChartData(selectedDate, isMonthly);
  }, [selectedDate, isMonthly]);

  useEffect(() => {
    fetchPatient();
    fetchUsageChartData();
  }, []);
  const therapies = [
    { name: "Relaxed Home", usage: 62 },
    { name: "Birds Mixer", usage: 57 },
    { name: "Nature Jungle", usage: 59 },
    { name: "Rainy with birds", usage: 55 },
    { name: "Garden", usage: 53 },
  ];

  useEffect(() => {
    fetchTherapyUsage(params.id);
  }, []);

  const handleDateNavigation = (direction) => {
    setSelectedDate((prev) => {
      if (!prev || !moment.isMoment(prev)) return moment(); // Ensure prev is always a moment object

      const newDate = isMonthly
        ? prev.clone().add(direction, "month")
        : prev.clone().add(direction, "week");

      fetchUsageChartData(newDate, isMonthly); // Fetch new data
      return newDate;
    });
  };

  const generateMonthlyData = () => {
    const startOfMonth = selectedDate.clone().startOf("month");
    const endOfMonth = selectedDate.clone().endOf("month");

    const days = [];
    let currentDay = startOfMonth.clone();

    while (currentDay.isSameOrBefore(endOfMonth, "day")) {
      const dateKey = currentDay.format("YYYY-MM-DD");
      days.push({
        label: {
          day: currentDay.format("dd"),
          date: currentDay.format("D"),
        },
        value: usageData[dateKey] || 0,
        isCurrentMonth: true,
      });

      currentDay.add(1, "day");
    }
    return days;
  };

  const generateWeeklyData = () => {
    const startOfWeek = selectedDate.clone().startOf("week");

    return Array.from({ length: 7 }, (_, i) => {
      const date = startOfWeek.clone().add(i, "day");
      return {
        label: {
          day: date.format("dd"), // Mo, Tu, We...
          date: date.format("D"),
        },
        value: usageData[date.format("YYYY-MM-DD")] || 0, // Fill missing dates with 0
      };
    });
  };

  /** Correctly formats navigation header */
  const getDateNavigatorLabel = () => {
    if (isMonthly) {
      const previousMonth = selectedDate.clone().subtract(1, "month");
      return `${selectedDate.format("MMMM YYYY")}`;
    } else {
      const startOfWeek = selectedDate.clone().startOf("week");
      const endOfWeek = selectedDate.clone().endOf("week");
      return `${startOfWeek.format("D MMM")} - ${endOfWeek.format(
        "D MMM YYYY"
      )}`;
    }
  };

  useEffect(() => {
    const startDate = isMonthly
      ? selectedDate.clone().startOf("month").toISOString()
      : selectedDate.clone().startOf("week").toISOString();
    const endDate = isMonthly
      ? selectedDate.clone().endOf("month").toISOString()
      : selectedDate.clone().endOf("week").toISOString();

    fetchUsageChartData(startDate, endDate);
  }, [selectedDate, isMonthly]);
  const title = "Patient details";

  const infoIconView = (data) => {
    console.log("Opening Modal for Patient:", data); 
    dispatch(
      openModal(<PatientInformationView data={data} />, "md", false, "information")
    );
  };
const todayDate = moment().format("DD MMM YYYY");
return (
    <PatientDashboardUi
      // title={title}
      loading={loading}
      patient={patient}
      todayUsage={todayUsage}
      weeklyUsage={weeklyUsage}
      therapies={therapies}
      therapyUsage={therapyUsage}
      onclickButton={onclickButton}
      handleDateNavigation={handleDateNavigation}
      generateMonthlyData={generateMonthlyData}
      generateWeeklyData={generateWeeklyData}
      getDateNavigatorLabel={getDateNavigatorLabel}
      infoIconView={infoIconView}
      todayDate={todayDate}
      isMonthly={isMonthly}
      setIsMonthly={setIsMonthly}
      selectedDate={selectedDate}
    />
  );
}  
export default PatientDashboardController;